export const dateToString = (d: Date) =>
    d.getFullYear().toString().padStart(4, '0') +
    '-' +
    (d.getMonth() + 1).toString().padStart(2, '0') +
    '-' +
    d.getDate().toString().padStart(2, '0');
